import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
type QA = {
  question: string;
  answer: string;
};
export const faqs: QA[] = [{
  question: 'What services does Oli Creative offer?',
  answer: 'Oli Creative offers presentation and pitch deck design, brochures and print collateral, website design, brand identity, business cards, marketing collateral, and email marketing design.'
}, {
  question: 'Who is the designer behind Oli Creative?',
  answer: 'Oli Creative is led by Mari Peixoto, an independent graphic designer with 12+ years of experience specializing in editorial layouts, typography, and visual storytelling for brands worldwide.'
}, {
  question: 'Where is Oli Creative based?',
  answer: 'Oli Creative is based in California, USA (Pacific Time) and works with clients globally, both remotely and across time zones.'
}, {
  question: 'How much does a presentation or pitch deck cost?',
  answer: 'Pricing depends on scope, length, and turnaround. Most presentation projects are quoted per deck after a short discovery call. Reach out via the contact form for a tailored estimate.'
}, {
  question: 'What is the typical turnaround time for a project?',
  answer: 'Turnaround varies by project size. A focused presentation or set of business cards can take a few days, while full brand identity or website projects typically run two to four weeks including revision rounds.'
}, {
  question: 'What design tools does Mari use?',
  answer: 'Mari works in Figma, Adobe InDesign, Illustrator, Photoshop, Keynote, Canva, and Google Slides, choosing the right tool for each deliverable across digital and print.'
}, {
  question: 'How do I start a project with Oli Creative?',
  answer: 'Fill out the contact form on this site or email marilyn.peixoto@gmail.com with your timeline, budget, and goals. Mari typically responds within 24 to 48 hours to schedule a kickoff.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 md:py-32 bg-cream-dark/50" data-id="element-71">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-72">
        <div className="text-center mb-16 md:mb-20" data-id="element-73">
          <h2 className="text-5xl md:text-7xl font-serif tracking-tight mb-6" data-id="element-74">
            Frequently <span className="italic text-ink-light" data-id="element-75">Asked</span>
          </h2>
          <p className="text-ink-light max-w-xl mx-auto" data-id="element-76">
            Everything you need to know about working with Oli Creative.
          </p>
        </div>

        <dl className="divide-y divide-ink/10 border-t border-b border-ink/10" data-id="element-77">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} data-id="element-78">
                <dt data-id="element-79">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-answer-${index}`} className="w-full flex items-center justify-between gap-6 py-6 text-left group focus:outline-none focus-visible:ring-2 focus-visible:ring-accent rounded-sm" data-id="element-80">
                    <span className="text-lg md:text-xl font-serif text-ink group-hover:text-accent transition-colors" data-id="element-81">
                      {faq.question}
                    </span>
                    <span className={`shrink-0 w-8 h-8 rounded-full border border-ink/20 flex items-center justify-center transition-all duration-300 ${isOpen ? 'bg-accent border-accent text-cream rotate-45' : 'text-ink group-hover:border-accent'}`} data-id="element-82">
                      <Plus size={16} data-id="element-83" />
                    </span>
                  </button>
                </dt>
                <AnimatePresence initial={false} data-id="element-84">
                  {isOpen && <motion.dd id={`faq-answer-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.35,
                ease: [0.76, 0, 0.24, 1]
              }} className="overflow-hidden" data-id="element-85">
                      <p className="text-ink-light leading-relaxed pb-6 pr-12 max-w-2xl" data-id="element-86">
                        {faq.answer}
                      </p>
                    </motion.dd>}
                </AnimatePresence>
              </div>;
        })}
        </dl>
      </div>
    </section>;
}